// @flow
import * as types from './types';

export function transformCategoryToRequestData(category: types.Category) {
  return {
    id: category.id,

    parentId: category.parentId,
    categoryType: category.type,

    name: category.name,
    description: category.description,
    isDeleted: category.isDeleted,

    isExcludedFromCategoryList: category.isExcludedFromCategoryList,
    knownCategoryId: category.knownCategoryId,
    logoUrl: category.logoUrl,
  };
}

export function transformResponseToCategories(response: any) {
  return response.data.resources.map((data) => (
    types.mkCategory({
      id: data.id,

      parentId: data.parentId,
      type: data.categoryType,

      name: data.name,
      description: data.description,
      isDeleted: data.isDeleted,

      isExcludedFromCategoryList: data.isExcludedFromCategoryList,
      knownCategoryId: data.knownCategoryId,
      logoUrl: data.logoUrl,
    })
  ));
}
